/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { getIdentities, searchIdentities } from 'src/azure/services/get-board-users';

export const supportedWorkItemUserFieldValues = [
	{ label: 'User Who Triggered The Event', value: 'UserWhoTriggeredTheEvent' },
	{ label: 'Work Item Creator', value: 'Custom.WorkItemCreator' },
	{ label: 'Work Item Assignee', value: 'Custom.WorkItemAssignee' },
];

export const useUserFieldHook = () => {
	const searchIdentityOptions = useCallback(async (text: string): Promise<Array<{ value: string; label: string }>> => {
		const staticResults = supportedWorkItemUserFieldValues.filter(item => item.label.toLowerCase().includes(text.toLowerCase()));	
		const identitiesResults = await searchIdentities(text);
		return [
			...staticResults,
			...identitiesResults.map((item: any) => ({
				label: `${item.displayName} <${item.signInAddress}>`,
				value: item.localId
			}))
		];
	}, []);
	
	const getIdentityOptions = useCallback(async (): Promise<Array<{ value: string; label: string }>> => {
		const identities = await getIdentities();
		return identities.map((item: any) => ({
			label: `${item.displayName} <${item.signInAddress}>`,
			value: item.localId
		}));
	}, []);

	const getIdentityById = useCallback(async (id: string): Promise<{ value: string; label: string }> => {
		const identities = await searchIdentities(id, { queryTypeHint: 'uid' });
		const found: any = identities.find((item: any) => item.localId === id);

		return {
			label: `${found.displayName} <${found.mail}>`,
			value: found.localId
		};
	}, []);

	return {
		searchIdentityOptions,
		getIdentityOptions,
		getIdentityById
	};
};